import {
  AppBar,
  Typography,
  Link,
  Box,
  Toolbar,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Drawer,
  Button,
  Menu,
  InputBase, Container, Breadcrumbs,
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import React, { FC, useCallback, useState } from 'react';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import MenuIcon from '@mui/icons-material/Menu';
import useStyles from '../../styles/styles';
import { useTheme, styled, alpha  } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useNavigate } from 'react-router-dom';
import { useConnection, useUserInfo } from '../../connection/Application';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import NotificationItem from '../Items/NotificationItem';
import SearchIcon from '@mui/icons-material/Search';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Category2 from '../Category/Category2';
import CbaMenu from './CbaMenu';

function ElevationScroll(props: any) {
  const { children } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

const links: {
  route: string;
  url: string;
  button: boolean;
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | undefined;
}[] = [
  // { route: 'Home', url: '/', button: false },
  // { route: 'About Us', url: '/about', button: false },
  // { route: 'Contact Us', url: '/contact', button: false },
  // { route: 'Testimonial', url: '/testimonial', button: false },
  { route: 'Sign Up', url: '/signup', button: true, color: 'primary' },
  { route: 'Login', url: '/login', button: true, color: 'secondary' },
];

const sLinks: {
  route: string;
  url: string;
  left: boolean;
}[] = [
  { route: 'Learning', url: '/', left: true },
  { route: 'Analytics', url: '/', left: true },
  { route: 'Takeoff', url: '/', left: true },
  { route: 'Inspiration', url: '/', left: false },
  { route: 'MemberShip', url: '/', left: false },
];

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha('#8c8c8c', 0.15),
  color: 'black',
  border: '1px solid #bababa',
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  maxWidth: '400px',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    // width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'relative',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 1),
    // vertical padding + font size from searchIcon
    // paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    color: 'black',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '38ch',
    },
  },
}));

const LinkList: FC<{
  anchor: string;
  toggleDrawer: (anchor: string, open: boolean, event: any) => void;
  onRouteClick: (link: string) => void;
}> = ({ anchor, toggleDrawer, onRouteClick }) => {
  const user = useUserInfo();
  return (
    <Box
      role='presentation'
      onClick={(event) => toggleDrawer(anchor, false, event)}
      onKeyDown={(event) => toggleDrawer(anchor, false, event)}>
      <List>
        <ListItem button>
          <ListItemText onClick={() => onRouteClick('/cba')} primary='O/L CBA Exam Papers' />
        </ListItem>
        {!user
          ? links.map((link: { route: string; url: string; button: boolean }, i) => (
              <ListItem button key={i}>
                <ListItemText onClick={() => onRouteClick(link.url)} primary={link.route} />
              </ListItem>
            ))
          : links
              .filter((d) => !d.button)
              .map((link: { route: string; url: string; button: boolean }, i) => (
                <ListItem button key={i}>
                  <ListItemText onClick={() => onRouteClick(link.url)} primary={link.route} />
                </ListItem>
              ))}
      </List>
    </Box>
  );
};

Object.defineProperty(String.prototype, 'capitalize', {
  value: function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false,
});


const Header: FC<{ category?: boolean, x?: any }> = ({ category, x }) => {
  const MySwal = withReactContent(Swal);
  const classes = useStyles();
  const user = useUserInfo();
  const navigate = useNavigate();
  const connection = useConnection();
  const [openMenu1, setOpenMenu1] = useState<any>(false);

  const logoutUser = async () => {
    // console.log('logout user from the website');

    MySwal.fire({
      title: 'Are you sure?',
      text: 'Do You want Logout this Site!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#4250ce',
      confirmButtonText: 'Yes, Logout it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        // MySwal.fire({
        //   title: 'Processing!',
        //   didOpen: () => {
        //     MySwal.showLoading();
        //   },
        //   allowOutsideClick: () => !MySwal.isLoading(),
        // }).then(async () => {
        //   console.log('');
        // });
        try {
          connection.setToken(undefined);
          navigate('/sign-in');
        } catch (e: any) {
          if (e.message) {
            await MySwal.fire('Error!', e.message, 'error');
          }
        }
      }
    });
  };

  const renderMenu1 = () => (
    <Menu
      anchorEl={openMenu1}
      anchorReference={undefined}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={Boolean(openMenu1)}
      onClose={handleCloseMenu1}
      sx={{ mt: 2 }}>
      <Link onClick={logoutUser}>
        <NotificationItem icon={<PowerSettingsNewIcon />} title='logout' />
      </Link>
    </Menu>
  );

  const handleOpenMenu1 = (event: any) => setOpenMenu1(event.currentTarget);
  const handleCloseMenu1 = () => setOpenMenu1(false);

  const [state, setState] = useState({ right: false });

  const toggleDrawer = useCallback((anchor: string, open: boolean, event: any) => {
    if (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  }, []);

  const onRouteClick = useCallback(
    (link: string) => {
      navigate(link, { replace: false });
    },
    [navigator],
  );

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const handleBreadcrumbClick = useCallback(
    (event: React.MouseEvent, mainTitleId?: string) => {
      event.preventDefault();
      if (!x?.category?.id || !x?.grade?.id) {
        return;
      }
      const mainTitleParam = mainTitleId ? `&mainTitle=${mainTitleId}` : '';
      navigate(`/home?category=${x.category.id}&grade=${x.grade.id}${mainTitleParam}`);
    },
    [navigate, x?.category?.id, x?.grade?.id],
  );

  return (
    <Toolbar
      sx={{
        marginBottom: '40px',
        background: '#fff',
        padding: '0 24px',
        height: 'auto',
        lineHeight: 'normal',
        borderBottom: '1px solid #f0f0f0',
      }}>
      <ElevationScroll>
        <AppBar style={{ background: 'transparent', boxShadow: 'none' }}>
          <Toolbar
            className={classes.toolBar}
            style={{ backgroundColor: '#ffffff', padding: '0 6%' }}>
            <Link href='/' underline='none'>
              <img src={'/MHT.png'} />
            </Link>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                // width: 'calc(100vw - 595px)'
                marginLeft: 'calc(44vw - 305.5px)',
              }}>
              <Search style={{ width: '100%', display: 'flex', background: '#FFF' }}>
                <StyledInputBase
                  placeholder='Search topics, skils and more'
                  inputProps={{ 'aria-label': 'search' }}
                  style={{ borderRight: '0.5px solid' }}
                />
                <SearchIconWrapper style={{ padding: '0 10px' }}>
                  <SearchIcon />
                </SearchIconWrapper>
              </Search>
            </div>
            <>
              {matches ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {user && (
                    <Box>
                      <Box color={'white'}>
                        <IconButton
                          size='large'
                          edge='end'
                          color='inherit'
                          disableRipple
                          aria-controls='notification-menu'
                          aria-haspopup='true'
                          // variant='contained'
                          onClick={handleOpenMenu1}>
                          <Typography style={{ color: 'black' }}>
                            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                            {/* @ts-ignore*/}
                            {user?.firstName?.capitalize() + ' '}
                          </Typography>
                          <AccountCircleIcon
                            style={{ width: 40, height: 40, marginLeft: 5 }}
                            className={classes.menuIcon}
                          />
                        </IconButton>
                        {renderMenu1()}
                      </Box>
                    </Box>
                  )}
                  <Box>
                    <IconButton
                      size='large'
                      edge='end'
                      color='inherit'
                      aria-label='menu'
                      onClick={(event) => toggleDrawer('right', true, event)}>
                      <MenuIcon className={classes.menuIcon} />
                    </IconButton>

                    <Drawer
                      anchor='right'
                      open={state['right']}
                      onClose={(event) => toggleDrawer('right', false, event)}>
                      {
                        <LinkList
                          anchor={'right'}
                          toggleDrawer={toggleDrawer}
                          onRouteClick={onRouteClick}
                        />
                      }
                    </Drawer>
                  </Box>
                </div>
              ) : (
                <>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      flex: 1,
                      alignItems: 'center',
                    }}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexGrow: '0.4',
                      }}>
                      {links
                        .filter((e) => !e.button)
                        .map((link, i) => (
                          <Link onClick={() => onRouteClick(link.url)} underline='none' key={i}>
                            <Typography className={classes.link}>{link.route}</Typography>
                          </Link>
                        ))}
                    </Box>
                  </Box>
                  {!user ? (
                    <Box
                      sx={{
                        display: 'flex',
                        flex: 0.6,
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                      }}>
                      {links
                        .filter((e) => e.button)
                        .map((link, i) => (
                          <Button
                            key={i}
                            onClick={() => onRouteClick(link.url)}
                            color={link?.color ?? 'primary'}
                            variant='contained'
                            sx={{
                              width: '150px',
                              fontSize: '16px',
                              borderRadius: '15px',
                              marginLeft: '20px',
                            }}>
                            {link.route}
                          </Button>
                        ))}
                    </Box>
                  ) : (
                    <Box>
                      <Box color={'white'}>
                        <IconButton
                          size='large'
                          edge='end'
                          color='inherit'
                          disableRipple
                          aria-controls='notification-menu'
                          aria-haspopup='true'
                          // variant='contained'
                          onClick={handleOpenMenu1}>
                          <Typography style={{ color: 'black' }}>
                            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                            {/* @ts-ignore*/}
                            {user?.firstName?.capitalize() + ' '}
                          </Typography>
                          <AccountCircleIcon
                            style={{ width: 40, height: 40, marginLeft: 5 }}
                            className={classes.menuIcon}
                          />
                        </IconButton>
                        {renderMenu1()}
                      </Box>
                    </Box>
                  )}
                </>
              )}
            </>
          </Toolbar>
          <Toolbar style={{ minHeight: '40px', backgroundColor: '#172C59', padding: '0 6%' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                flex: 1,
                alignItems: 'center',
              }}>
              <Box
                sx={{
                  display: 'flex',
                  // justifyContent: 'space-between',
                  alignItems: 'left',
                  flexGrow: '0.5',
                }}>
                {sLinks
                  .filter((e) => e.left)
                  .map((link, i) => (
                    <React.Fragment key={i}>
                      <Link
                        onClick={() => onRouteClick(link.url)}
                        underline='none'
                        paddingRight={4}
                        sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography className={classes.link} style={{ color: 'white' }}>
                          {link.route}
                        </Typography>
                      </Link>
                      {/* The assessments menu sits right after Learning. */}
                      {i === 0 && <CbaMenu />}
                    </React.Fragment>
                  ))}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  flexGrow: '0.5',
                }}>
                {sLinks
                  .filter((e) => !e.left)
                  .map((link, i) => (
                    <Link
                      onClick={() => onRouteClick(link.url)}
                      paddingRight={4}
                      underline='none'
                      key={i}>
                      <Typography className={classes.link} style={{ color: 'white' }}>
                        {link.route}
                      </Typography>
                    </Link>
                  ))}
              </Box>
            </Box>
            {/* Learning English Skills Textbooks Diagnostic Analytics MEMBERSHIP*/}
          </Toolbar>
          {category && (
            <>
              <Category2 sticky={false} />
            </>
          )}
          {Array.isArray(x?.crumbs) && (
            <div
              style={{ width: '100%', height: '35px', background: '#F1EFF4', paddingTop: '4px' }}>
              <Container>
                {/* A page outside the question flow passes its own trail as
                      `x.crumbs`; the last one is the page itself. */}
                {Array.isArray(x?.crumbs) && (
                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize='small' />}
                    aria-label='breadcrumb'
                    style={{ marginBottom: '10px' }}>
                    {x.crumbs.map((crumb: { label: string; href: string }, i: number) =>
                      i === x.crumbs.length - 1 ? (
                        <Typography
                          key={crumb.href}
                          sx={{ color: 'text.primary', fontWeight: '700' }}>
                          {crumb.label}
                        </Typography>
                      ) : (
                        <Link
                          underline='hover'
                          key={crumb.href}
                          color='inherit'
                          href={crumb.href}
                          onClick={(event: React.MouseEvent) => {
                            event.preventDefault();
                            navigate(crumb.href);
                          }}>
                          {crumb.label}
                        </Link>
                      ),
                    )}
                  </Breadcrumbs>
                )}
                {!Array.isArray(x?.crumbs) && (x?.grade?.id ?? '') !== '' && (
                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize='small' />}
                    aria-label='breadcrumb'
                    style={{ marginBottom: '10px' }}>
                    <Link
                      underline='hover'
                      key='1'
                      color='inherit'
                      href={`/home?category=${x.category.id}&grade=${x.grade.id}`}
                      onClick={(event) => handleBreadcrumbClick(event)}>
                      {x?.grade.value}
                    </Link>
                    ,
                    <Link
                      underline='hover'
                      key='2'
                      color='inherit'
                      href={`/home?category=${x.category.id}&grade=${x.grade.id}`}
                      onClick={(event) => handleBreadcrumbClick(event)}>
                      {x.category.value}
                    </Link>
                    ,
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Link
                        underline='hover'
                        key='2'
                        color='inherit'
                        href={`/home?category=${x.category.id}&grade=${x.grade.id}&mainTitle=${x.mainTitle.id}`}
                        onClick={(event) => handleBreadcrumbClick(event, x.mainTitle.id)}>
                        <Typography key='3' sx={{ color: 'text.primary', fontWeight: '700' }}>
                          {`${x.mainTitle.orderNum}) ${x.mainTitle.value}`}
                        </Typography>
                      </Link>
                      {x.mainTitle.pdf && (
                        <a href={x.mainTitle.pdf} target='_blank' rel='noreferrer'>
                          <img
                            src={'/pdf.png'}
                            style={{ width: '30px', paddingLeft: '10px', paddingTop: '5px' }}
                          />
                        </a>
                      )}
                    </div>
                  </Breadcrumbs>
                )}
              </Container>
            </div>
          )}
          {(x?.grade?.id ?? '') !== '' && (
            <div
              style={{ width: '100%', height: '35px', background: '#F1EFF4', paddingTop: '4px' }}>
              <Container>
                {/* A page outside the question flow passes its own trail as
                      `x.crumbs`; the last one is the page itself. */}
                {Array.isArray(x?.crumbs) && (
                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize='small' />}
                    aria-label='breadcrumb'
                    style={{ marginBottom: '10px' }}>
                    {x.crumbs.map((crumb: { label: string; href: string }, i: number) =>
                      i === x.crumbs.length - 1 ? (
                        <Typography
                          key={crumb.href}
                          sx={{ color: 'text.primary', fontWeight: '700' }}>
                          {crumb.label}
                        </Typography>
                      ) : (
                        <Link
                          underline='hover'
                          key={crumb.href}
                          color='inherit'
                          href={crumb.href}
                          onClick={(event: React.MouseEvent) => {
                            event.preventDefault();
                            navigate(crumb.href);
                          }}>
                          {crumb.label}
                        </Link>
                      ),
                    )}
                  </Breadcrumbs>
                )}
                {!Array.isArray(x?.crumbs) && (x?.grade?.id ?? '') !== '' && (
                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize='small' />}
                    aria-label='breadcrumb'
                    style={{ marginBottom: '10px' }}>
                    <Link
                      underline='hover'
                      key='1'
                      color='inherit'
                      href={`/home?category=${x.category.id}&grade=${x.grade.id}`}
                      onClick={(event) => handleBreadcrumbClick(event)}>
                      {x?.grade.value}
                    </Link>
                    ,
                    <Link
                      underline='hover'
                      key='2'
                      color='inherit'
                      href={`/home?category=${x.category.id}&grade=${x.grade.id}`}
                      onClick={(event) => handleBreadcrumbClick(event)}>
                      {x.category.value}
                    </Link>
                    ,
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Link
                        underline='hover'
                        key='2'
                        color='inherit'
                        href={`/home?category=${x.category.id}&grade=${x.grade.id}&mainTitle=${x.mainTitle.id}`}
                        onClick={(event) => handleBreadcrumbClick(event, x.mainTitle.id)}>
                        <Typography key='3' sx={{ color: 'text.primary', fontWeight: '700' }}>
                          {`${x.mainTitle.orderNum}) ${x.mainTitle.value}`}
                        </Typography>
                      </Link>
                      {x.mainTitle.pdf && (
                        <a href={x.mainTitle.pdf} target='_blank' rel='noreferrer'>
                          <img
                            src={'/pdf.png'}
                            style={{ width: '30px', paddingLeft: '10px', paddingTop: '5px' }}
                          />
                        </a>
                      )}
                    </div>
                  </Breadcrumbs>
                )}
              </Container>
            </div>
          )}

          {/* <img*/}
          {/*  src={'/cloud.png'}*/}
          {/*  className={classes.dropShadow}*/}
          {/*  style={{*/}
          {/*    width: '100%',*/}
          {/*    height: '60px',*/}
          {/*    marginTop: '-25px',*/}
          {/*    filter:*/}
          {/*      'drop-shadow(0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);)',*/}
          {/*  }}*/}
          {/* />*/}
        </AppBar>
      </ElevationScroll>
    </Toolbar>
  );
};

export default Header;
